var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.open &&
    'bg-black fixed h-screen left-0 opacity-40 top-0 w-screen z-30 lg:bg-transparent',on:{"click":_vm.toggle}})}
var staticRenderFns = []

export { render, staticRenderFns }